import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { Divider, SvgIcon, Switch, Tooltip } from '@mui/material';
import { ExpandLess, ExpandMore, Logout } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Logo } from 'components'
import { ReactComponent as CommentsIcon } from 'assets/icons/Comments.svg';
import { Header, Content, WrapSubItems, BrokenDisplayStyles, WrapFooter, UserName, UserEmail, UserDetails, SelectRoleStyles, FooterStyles } from './Style'
import { constants } from './hooks'
import { Button, SideBarItem } from 'components/Form';
import { app } from 'router/routes';
import { SideBarContext } from 'components/SideBar/SideBarContext';
import { sidebarHooks, SystemBtns } from '.';
import { useDispatch } from 'react-redux';
import { actions } from 'store';
import { authHooks } from 'pages/Auth';
import { useQueryClient } from '@tanstack/react-query';
import { alerts, queryClient as qc } from 'keys'
import { Img } from 'styles/GlobalStyle';
import { roleHooks } from 'pages/Roles';
import { SelectRolePopup } from 'pages';
import { secretStorage } from 'config';
import { useAlert } from 'components/Alerts/hooks';
import { primary500 } from 'styles/theme';

const SideBarItems = (props) => {
    const { closeDrawer } = props
    const { selectedSubItem, selectedItem, system } = useContext(SideBarContext)
    const { defaultRole, user } = useSelector(state => state.user)
    const { brokenDisplay } = useSelector(state => state.general)
    const secretUser = secretStorage.getItem("user")

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const queryClient = useQueryClient()

    const { setAlerts } = useAlert()
    const menuItems = sidebarHooks.useMenuItems()
    const { logout, logoutPending } = authHooks.useLogout()
    const roleList = roleHooks.useRoleList()

    const { first_name, last_name, email } = user || {}
    const cleanData = () => {
        dispatch(actions.setTestTaker({}))
        dispatch(actions.setAssessment({}))
    }

    const changeSubItem = (subItem) => {
        const { id, path, cleanTestTaker } = subItem
        cleanTestTaker && cleanData()
        navigate(path)
    }

    const changeItem = (item) => {
        const { id, path, cleanTestTaker } = item
        queryClient.invalidateQueries([qc.ticketTypeCounts])

        if (item.subItems && item.hide) {
            changeSubItem(item.subItems[0])
        }
        else {
            cleanTestTaker && cleanData()
            navigate(path)
        }
    }

    const navigateApp = () => {
        navigate(app.app)
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const updateBrokenDisplay = useCallback((_, val) => {
        dispatch(actions.setBrokenDisplay(val))
    }, [])

    const openNewTicketAlert = useCallback(() => {
        setAlerts(alerts.contactUs, true)
    }, [])

    const filteredMenuItems = useMemo(() => {
        return menuItems.filter(item => item.system === system.id);
    }, [menuItems, system.id]);

    const ExpandIcon = open ? ExpandLess : ExpandMore

    return (
        <React.Fragment>
            <Header>
                <BrokenDisplayStyles>
                    <Logo action={navigateApp} width={40} height={40} />
                    <div className='chanage-broken-value'>
                        <Tooltip placement='bottom' title={brokenDisplay ? "הסתרת פרטים אישיים פעיל" : "הסתרת פרטים אישיים מכובה"}>
                            <Switch
                                checked={brokenDisplay}
                                onChange={updateBrokenDisplay}
                                color="secondary" />
                        </Tooltip>
                    </div>
                </BrokenDisplayStyles>
                {user &&
                    <UserDetails>
                        <UserName>
                            {constants.welcome(user?.gender)}
                        </UserName>
                        <UserEmail>
                            {`
                            ${first_name ? first_name : ""} 
                            ${last_name ? last_name : ""}`
                            }
                        </UserEmail>
                    </UserDetails>
                }
            </Header>
            {
                defaultRole && secretUser.user_data?.length > 1 &&
                <React.Fragment>
                    <SelectRoleStyles onClick={handleClick}>
                        <div className='role-details'>
                            <div className='role-icon'>
                                <Img src={roleList[defaultRole.role_name]?.icon || roleList["default"].icon} />
                            </div>
                            <div>
                                {defaultRole.role_label}
                            </div>
                        </div>
                        <ExpandIcon />
                    </SelectRoleStyles>
                    <SelectRolePopup
                        open={open}
                        anchorEl={anchorEl}
                        handleClose={handleClose} />
                </React.Fragment>
            }
            <SystemBtns />
            <Content>
                {filteredMenuItems.map((item, index) => {
                    return (
                        <div key={item.name}>
                            <SideBarItem
                                {...item}
                                action={(event) => {
                                    closeDrawer?.(event)
                                    changeItem(item)
                                }}
                                selected={selectedItem === item.name}
                                role="read"
                                permissionHOC="hidden"
                            />
                            {selectedItem === item.name && item.subItems &&
                                <WrapSubItems>
                                    {item.subItems?.map((subItem, index) =>
                                        <SideBarItem
                                            {...subItem}
                                            key={subItem.name}
                                            subItem
                                            action={() => changeSubItem(subItem)}
                                            selected={selectedSubItem === subItem.name}
                                            hideBorder
                                            role="read"
                                            permissionHOC="hidden"
                                        />
                                    )}
                                </WrapSubItems>
                            }
                        </div>
                    )
                })}

            </Content>
            <FooterStyles>
                <div className='add-comment-btn'>
                    <Button
                        className="solid-round2"
                        color={"primary500"}
                        fullWidth
                        disabled={logoutPending}
                        icon={<SvgIcon size="small" component={CommentsIcon} inheritViewBox />}
                        action={openNewTicketAlert}
                        label={"עזרה ומשוב"}
                    />
                </div>
                <Divider sx={{ borderColor: "#416783", width: "100%" }} />
                <SideBarItem
                    disabled={logoutPending}
                    icon={Logout}
                    action={logout}
                    label={logoutPending ? "מתנתק..." : "התנתק"}
                />
            </FooterStyles>
        </React.Fragment >
    )
}

export default SideBarItems